import React from "react";
import { useEventModal } from "../../hooks/EventHook";
import { WP_Event } from "../../model/models";
import { Modal } from "../globals/Modal";
import { SanitizeHTML } from "../globals/SanitizeHTML";
import { EventModalContent } from "./EventModaleContent";
import { FormattedMessage } from "react-intl";
import { ClockIcon } from "./ClockIcon";

export const EventItemSimple = (
  event: WP_Event,
  baseUrl: string,
  key: number
) => {
  const {
    start_date,
    start_hour,
    end_date,
    end_hour,
    event_start_date_house,
    end_date_hour,
    eventHouseThumbnailUrl,
    eventHouseName,
    featuredImage,
    places,
  } = useEventModal(event);

  return (
    <li key={key}>
      <Modal
        content={
          <EventModalContent
            event={event}
            start_date={start_date}
            start_hour={start_hour}
            end_date={end_date}
            end_hour={end_hour}
            eventHouseThumbnailUrl={eventHouseThumbnailUrl}
            eventHouseName={eventHouseName}
            places={places}
          />
        }
        ModalUrl={baseUrl + "/" + event.slug}
        backUrl={baseUrl}
      >
        <div className="events-block mb-8 md:mb-0 md:bg-white md:rounded-2xl md:p-4">
          <div className="event-thumbnail-event">
            {featuredImage && (
              <img className="rounded-2xl w-full" src={featuredImage} alt="" />
            )}
          </div>
          <div className="flex flex-col justify-between events-headcontent ml-3">
            <SanitizeHTML
              tag="h2"
              className="text-sm font-sans font-medium text-left text-black"
              html={event.title.rendered}
            />
            <div className="flex items-center flex-start event-dates">
              <ClockIcon className="text-gray-600 w-3 h-3" />

              <label className="text-xs font-sans opacity-60 leading-3 ml-1 text-black md:text-xs">
                {event_start_date_house}
              </label>
              {end_date !== "" && (
                <label className="text-xs font-sans opacity-60 ml-1 leading-3 text-black md:text-xs">
                  <FormattedMessage id="To" /> {end_date_hour}
                </label>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </li>
  );
};
